import { render, staticRenderFns } from "./commonSwitch.vue?vue&type=template&id=78ab8332&scoped=true"
import script from "./commonSwitch.vue?vue&type=script&lang=js"
export * from "./commonSwitch.vue?vue&type=script&lang=js"
import style0 from "./commonSwitch.vue?vue&type=style&index=0&id=78ab8332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ab8332",
  null
  
)

export default component.exports